<template>
    <div class="select-li" v-if="diningRoomId">
        <div class="inside_pages_right_content_top_left">
            <template>
                <el-tabs v-model="diningIdString" @tab-click="selCanteen">
                    <el-tab-pane v-for="(item, index) in canteenList" :key="index" :label="item.diningRoomName" :name="item.id.toString()"></el-tab-pane>
                </el-tabs>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name:'foodCanteenSelect',
    components: {},
    props: {},
    data() {
        return {
            canteenList: [],
            diningIdString: '',
            diningRoomId: 0
        };
    },
    created() {
        this.getCanteenList();
    },
    mounted() {},
    watch: {},
    computed: {},
    methods: {
        // 选择餐厅
        selCanteen() {
            // console.log(typeof(this.diningIdString))
            this.diningRoomId = Number(this.diningIdString);
            // console.log(this.diningRoomId)
            this.$store.commit('updateDiningRoomId',this.diningRoomId);
        },
        // 获取食堂(明厨亮灶)
        async getCanteenList(){
            let req = {
                schoolId: this.$store.state.schoolId
            }
            let res =  await this.$Http.getCanteenCameraCanteenList(req)
            if(res.code == 200){
                // console.log(res)
                this.canteenList = res.data || []
                if(this.canteenList.length > 0) {
                    this.diningRoomId = this.canteenList[0].id;
                    this.diningIdString = this.canteenList[0].id.toString();
                    this.$store.commit('updateDiningRoomId',this.diningRoomId);
                }
            }else if(res.code == 101){
                this.canteenList = []
            } else {
                this.$message({
                    type: 'info',
                    message: res.messsage
                });
            }

        },
    }
};
</script>
<style scoped>
.select-li{
    width: 100%;
    height: 54px;
}
</style>